import { render, staticRenderFns } from "./PsNotificationItem.vue?vue&type=template&id=31227f14&"
import script from "./PsNotificationItem.vue?vue&type=script&lang=js&"
export * from "./PsNotificationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports